import { TurnkeyWalletSessionException } from '@injectivelabs/exceptions'
import { Modal } from '@/types'

type HandleTurnkeyWalletSessionExceptionParams = {
  onDisconnectError?: (error: unknown) => void
}

export function useTurnkeySession() {
  function isTurnkeyWalletSessionException(error: unknown) {
    if (!(error instanceof Error)) {
      return false
    }

    return error.name === TurnkeyWalletSessionException.errorClass
  }

  async function handleTurnkeyWalletSessionException({
    onDisconnectError
  }: HandleTurnkeyWalletSessionExceptionParams = {}) {
    const modalStore = useSharedModalStore()
    const walletStore = useWalletStore()

    try {
      await walletStore.disconnect()
    } catch (error) {
      onDisconnectError?.(error)
    }

    modalStore.openModal(Modal.Connect)
  }

  return {
    isTurnkeyWalletSessionException,
    handleTurnkeyWalletSessionException
  }
}
